import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const ISO_DATE = 'YYYY-MM-DD';

export const todayISO = () => dayjs().format(ISO_DATE);

export const toISODate = (value) => dayjs(value).format(ISO_DATE);

export const isValidISODate = (value) =>
  typeof value === 'string' && dayjs(value, ISO_DATE, true).isValid();

/** True when the YYYY-MM-DD date is before today (local time). */
export const isPastDate = (value) =>
  isValidISODate(value) && dayjs(value, ISO_DATE).isBefore(dayjs(), 'day');

/**
 * Date for a fresh search: today, or tomorrow once it's 4 PM or later —
 * most same-day windows have closed by then.
 */
export function defaultSearchDate() {
  const now = dayjs();
  return (now.hour() >= 16 ? now.add(1, 'day') : now).format(ISO_DATE);
}

/** Reads ?date= and falls back to the default search date when missing, malformed or past. */
export function resolveSearchDate(value) {
  if (isValidISODate(value) && !isPastDate(value)) return value;
  return defaultSearchDate();
}

export const addDays = (value, days) =>
  dayjs(value, ISO_DATE).add(days, 'day').format(ISO_DATE);

/** Combines a YYYY-MM-DD date with an HH:mm:ss time into a dayjs instance. */
export function dateAtTime(date, time) {
  return dayjs(`${date} ${time || '00:00:00'}`, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD H:mm:ss', 'YYYY-MM-DD HH:mm']);
}
